
import { useCallback, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { buscadorCajaVentas, buscadorGlobalAdmin, rastrearOrdenProduccion, recalcularVentaCaja } from "../../../services";
import { useSearchParams } from "react-router-dom";




export const useRastrearOrdenProduccion = () => {
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['buscador-global', termino], 
        queryFn: () => rastrearOrdenProduccion(termino),
        staleTime: 1000 * 60 * 10,  
        gcTime: 1000 * 60 * 30
    });

    const chageTermino = useCallback((valor) => {
        setTermino(valor)
    }, []);

    
    return {
        termino,
        chageTermino,
        data, isLoading,
    }
}




export const useBuscadorGlobal = () => {
    // const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['buscador-global', termino], 
        queryFn: () => buscadorGlobalAdmin(termino),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 10,  
        gcTime: 1000 * 60 * 30
    });

    const chageTermino = useCallback((valor) => {
        setTermino(valor)
    }, []);

    
    return {
        // Estados
        termino,
        // Metodos
        chageTermino,
        data, isLoading,
    }
}






export const useBuscadorVentasCaja = () => {
    
    const [searchParams, setSearchParams] = useSearchParams();
    
    const page = parseInt(searchParams.get('page') || '0');
    const termino = searchParams.get('termino') || '';
    const medio = searchParams.get('medio') || '';
    const inicio = searchParams.get('inicio') || '';
    const final = searchParams.get('final') || '';

    const { data, isLoading } = useQuery({
        queryKey: ['venta-caja', { page, termino, inicio, final, medio }], 
        queryFn: () => buscadorCajaVentas({ page, termino, inicio, final, medio }),
    });


    const totalesVentaCaja = useQuery({
        queryKey: ['venta-caja-totales', { termino, inicio, final, medio } ],
        queryFn: () => recalcularVentaCaja({ termino, inicio, final, medio }),
    });


    const chagePage = useCallback((num) => {
        setSearchParams(prev => {
            prev.set('page', (num - 1).toString());
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageTermino = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('termino', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageMedioPago = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('medio', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageInicio = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('inicio', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);


    const chageFinal = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('final', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);



    return {
        // Estados
        page,
        termino,
        inicio,
        final,
        medio,
        // Métodos
        chagePage,
        chageTermino,
        chageInicio,
        chageMedioPago,
        chageFinal,
        data, isLoading,
        totalesVentaCaja,
    }
}